import React, { useEffect } from 'react';
import Classes from './Home.module.css';
import Hero from './Sections/Hero/Hero';
import Faq from './Sections/Faq/Faq';
import Footer from '../../GlobalComp/Footer/Footer';
import Services from './Sections/Services/Services';
import { useLocation, useNavigate } from 'react-router-dom';
import { scrollToElement } from '../../../utils/scrollToElement';
import { Helmet } from 'react-helmet-async';
import Review from './Sections/Review/Review';
import Benefits from './Sections/Benefits/Benefits';
import ServiceAreas from '../ServicePages/ServiceAreas';

function Home() {

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const scrollInfo = location.state?.scrollTo;
    if (scrollInfo) {
      setTimeout(() => {
        scrollToElement(scrollInfo.id, scrollInfo.offset);

        navigate(location.pathname, { replace: true, state: {} });
      }, 100);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  return (
    <div className={Classes.hero} >
      <Helmet>
        <title>Dryer Vent Cleaning in Boca Raton & South Florida | Quick Vents and Appliance Repair</title>
        <meta name="description"
          content="Dryer vent cleaning and appliance repair in Boca Raton and across Palm Beach and Broward Counties. Licensed, insured, fast scheduling. Call (561) 929-5476 or book online." />
        <link rel="canonical" href="https://www.quickvents.com/" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Dryer Vent Cleaning in Boca Raton & South Florida | Quick Vents and Appliance Repair" />
        <meta property="og:description" content="Dryer vent cleaning and appliance repair in Boca Raton and across Palm Beach and Broward Counties. Licensed, insured, fast scheduling. Call (561) 929-5476 or book online." />
        <meta property="og:url" content="https://www.quickvents.com/" />
      </Helmet>

      <Hero />
      <Services />
      {/* <WhyChooseUs /> */}
      <Benefits />
      <Review />
      <ServiceAreas />
      <Faq />
      <Footer />
    </div>
  );
}

export default Home;
